import React, { useEffect, useRef } from "react";

function ParticleBackground() {

  const canvasRef = useRef(null);

  useEffect(() => {

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    let particles = [];

    let mouse = {
      x: null,
      y: null,
    };

    const resizeCanvas = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };

    resizeCanvas();

    window.addEventListener("resize", resizeCanvas);

    class DustParticle {

      constructor() {

        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;

        this.size = Math.random() * 2 + 0.3;

        this.speedX = (Math.random() - 0.5) * 0.15;
        this.speedY = (Math.random() - 0.5) * 0.15;

        this.opacity = Math.random() * 0.5 + 0.1;
      }

      draw() {

        ctx.beginPath();

        ctx.arc(
          this.x,
          this.y,
          this.size,
          0,
          Math.PI * 2
        );

        ctx.fillStyle = `rgba(221,219,205,${this.opacity})`;

        ctx.fill();
      }

      update() {

        this.x += this.speedX;
        this.y += this.speedY;

        // subtle mouse movement
        if (mouse.x && mouse.y) {

          let dx = mouse.x - this.x;
          let dy = mouse.y - this.y;

          let dist = Math.sqrt(dx * dx + dy * dy);

          if (dist < 120) {

            this.x -= dx * 0.002;
            this.y -= dy * 0.002;
          }
        }

        // reset
        if (this.x < 0) this.x = canvas.width;
        if (this.x > canvas.width) this.x = 0;

        if (this.y < 0) this.y = canvas.height;
        if (this.y > canvas.height) this.y = 0;

        this.draw();
      }
    }

    function init() {

      particles = [];

      for (let i = 0; i <800; i++) {
        particles.push(new DustParticle());
      }
    }

    function drawFilmGrain() {

      const grain = 18;

      for (let i = 0; i < grain; i++) {

        ctx.fillStyle = `rgba(255,255,255,${Math.random() * 0.03})`;

        ctx.fillRect(
          Math.random() * canvas.width,
          Math.random() * canvas.height,
          1,
          1
        );
      }
    }

    function animate() {

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach((particle) => particle.update());

      drawFilmGrain();

      requestAnimationFrame(animate);
    }

    window.addEventListener("mousemove", (e) => {

      const rect = canvas.getBoundingClientRect();

      mouse.x = e.clientX - rect.left;
      mouse.y = e.clientY - rect.top;
    });

    init();
    animate();

  }, []);

  return <canvas ref={canvasRef} className="particle-canvas"></canvas>;
}

export default ParticleBackground;